export default __webpack_public_path__ + "static/media/holy-sprit-with-ed1.c75a2158.jpg";